<template>
    <div>
        <div v-for="(shipitem, k) in task.shipmentItems" :key="k">
            <template v-if="shipitem.quantity !='0'">
                <div v-if="checkIfSalesBillOfMaterial(task, 'shipmentItems')">
                    <div
                        v-if="
                            (toLowerTitle(task.shipmentItems[0]) ||
                                toLowerArticleNumber(task.shipmentItems[0]) ||
                                toLowerTask(task)) == true ||
                            search === ''
                        "
                        class="bg-grey shadow-md rounded p-4 border border-white mb-4"
                        :class="
                            task.status === 'NEW'
                                ? 'border-blue-500	'
                                : task.status === 'SHIPPED'
                                ? 'border-green-500'
                                : 'border-yellow-500'
                        "
                    >
                        <div v-if="shown">
                            <div v-if="task.shipmentItems[0].local_article.length">
                                <div
                                    v-for="article in task.shipmentItems[0]
                                        .local_article"
                                    :key="article.id"
                                >
                                    <template v-if="article.media.length">
                                        <template v-for="(media, j) in article.media">
                                            <img
                                                v-if="
                                                    article.image_location ===
                                                        'weclapp' &&
                                                    media.collection_name ===
                                                        'weclapp_images'
                                                "
                                                class="w-full object-contain my-3 h-56"
                                                :src="media.original_url"
                                                :alt="media.name"
                                            />
                                            <img
                                                v-else-if="
                                                    article.image_location ===
                                                        'local' &&
                                                    media.collection_name === 'main'
                                                "
                                                class="w-full object-contain my-3 h-56"
                                                :src="media.original_url"
                                                :alt="media.name"
                                            />
                                        </template>
                                    </template>
                                    <img
                                        v-else-if="defaultArticleImage"
                                        :src="'/storage/' + defaultArticleImage"
                                        alt="default-article-img"
                                        class="w-full object-contain my-3 h-56"
                                    />
                                    <img
                                        v-else
                                        src="/img/dummyimg.jpg"
                                        alt="dummy-img"
                                        class="w-full object-contain my-3 h-56"
                                    />
                                </div>
                            </div>
                            <img
                                v-else-if="defaultArticleImage"
                                :src="'/storage/' + defaultArticleImage"
                                alt="default-article-img"
                                class="w-full object-contain my-3 h-56"
                            />
                            <img
                                v-else
                                src="/img/dummyimg.jpg"
                                alt="dummy-img"
                                class="w-full object-contain my-3 h-56"
                            />
                        </div>

                        <div
                            class="xl:flex xl:flex-wrap xl:justify-between xl:items-center mb-3"
                        >
                            <h2
                                class="text-sm lg:text-base headline cursor-pointer"
                                @click="
                                    toggleShipmentModal(
                                        task,
                                        task.shipmentItems[0].id,
                                        'sales_bill'
                                    )
                                "
                                v-if="task.shipmentItems[0].title"
                            >
                                {{ task.shipmentItems[0].title }}
                            </h2>
                            <h2 v-else>N/A</h2>
                            <h3 class="mt-3 xl:mt-0">
                                <p class="flex flex-wrap">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-5 w-5"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                                        /></svg>#{{ task.salesOrderNumber }}
                                </p>
                            </h3>
                        </div>
                        <p class="my-2">
                            {{ task.shipmentItems[0].articleNumber }}
                        </p>
                        <badge v-if="task.status" :color="badgeColor">
                            {{ ___("Status|" + task.status + "|content") }}
                        </badge>

                        <p
                            v-if="
                                includeShipmentTrackingLink && task.packageTrackingUrl
                            "
                            class="mt-5 inline-flex"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-5 h-5 mr-1"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
                                />
                            </svg>

                            <a
                                v-if="isTrackingLinkAssemblyEnabled"
                                :href="
                                    assembleTrackingLink(
                                        task.packageTrackingUrl,
                                        trackingVariable,
                                        task.packageTrackingNumber
                                    )
                                "
                                target="_blank"
                            >
                                {{ ___("Pipeline|Tracking link|content") }}
                            </a>
                            <a v-else :href="task.packageTrackingUrl" target="_blank">
                                {{ ___("Pipeline|Tracking link|content") }}
                            </a>
                        </p>

                        <div class="flex justify-between items-center flex-wrap mt-3">
                            <div
                                v-if="task.shippingDate"
                                class="relative group cursor-pointer inline-flex items-center"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-5 w-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                                <span
                                    v-if="task.status == 'SHIPPED'"
                                    v-html="formatDate(task.shippingDate)"
                                ></span>
                                <div
                                    class="absolute bottom-0 hidden mb-6 group-hover:flex flex-col"
                                >
                                    <span
                                        class="relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-black shadow-lg"
                                    >
                                        <span v-if="task.status == 'SHIPPED'">
                                            {{
                                                ___("Pipeline|Shipped Date|content")
                                            }}</span
                                        >
                                        <span v-else>
                                            {{
                                                ___("Pipeline|Not shipped yet|content")
                                            }}</span
                                        >
                                    </span>
                                    <div
                                        class="w-3 h-3 -mt-2 ml-1 transform rotate-45 bg-black"
                                    ></div>
                                </div>
                            </div>
                            <div
                                v-if="task.shipmentItems[0].quantity"
                                class="relative group cursor-pointer inline-flex items-center"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-5 w-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                                    />
                                </svg>
                                <span>{{ task.shipmentItems[0].quantity }}</span>
                                <div
                                    class="absolute bottom-0 hidden mb-6 group-hover:flex flex-col"
                                >
                                    <span
                                        class="relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-black shadow-lg"
                                    >
                                        {{ ___("Pipeline|Quantity|content") }}</span
                                    >
                                    <div
                                        class="w-3 h-3 -mt-2 ml-1 transform rotate-45 bg-black"
                                    ></div>
                                </div>
                            </div>

                            <button
                                aria-label="Open Detail Modal"
                                type="button"
                                @click="
                                    toggleShipmentModal(
                                        task,
                                        task.shipmentItems[0].id,
                                        'sales_bill'
                                    )
                                "
                                class="rounded-full outline-none focus:outline-none"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    x="0px"
                                    y="0px"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 172 172"
                                    style="fill: #000000"
                                >
                                    <g
                                        fill="none"
                                        fill-rule="nonzero"
                                        stroke="none"
                                        stroke-width="1"
                                        stroke-linecap="butt"
                                        stroke-linejoin="miter"
                                        stroke-miterlimit="10"
                                        stroke-dasharray=""
                                        stroke-dashoffset="0"
                                        font-family="none"
                                        font-weight="none"
                                        font-size="none"
                                        text-anchor="none"
                                        style="mix-blend-mode: normal"
                                    >
                                        <path
                                            d="M0,172v-172h172v172z"
                                            fill="none"
                                        ></path>
                                        <g fill="#000000">
                                            <path
                                                d="M86,14.33333c-39.49552,0 -71.66667,32.17115 -71.66667,71.66667c0,39.49552 32.17115,71.66667 71.66667,71.66667c39.49552,0 71.66667,-32.17115 71.66667,-71.66667c0,-39.49552 -32.17115,-71.66667 -71.66667,-71.66667zM86,28.66667c31.74921,0 57.33333,25.58412 57.33333,57.33333c0,31.74921 -25.58412,57.33333 -57.33333,57.33333c-31.74921,0 -57.33333,-25.58412 -57.33333,-57.33333c0,-31.74921 25.58412,-57.33333 57.33333,-57.33333zM78.83333,50.16667v14.33333h14.33333v-14.33333zM78.83333,78.83333v43h14.33333v-43z"
                                            ></path>
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div
                            v-if="
                                (toLowerTitle(shipitem) ||
                                    toLowerArticleNumber(shipitem) ||
                                    toLowerTask(task)) == true || search === ''
                            "
                            class="bg-grey shadow-md rounded p-4 border border-white mb-4"
                            :class="
                                task.status === 'NEW'
                                    ? 'border-blue-500	'
                                    : task.status === 'SHIPPED'
                                    ? 'border-green-500'
                                    : 'border-yellow-500'
                            "
                        >
                            <div v-if="shown">
                                <div v-if="shipitem.local_article.length">
                                    <div
                                        v-for="article in shipitem.local_article"
                                        :key="article.id"
                                    >
                                        <template v-if="article.media.length">
                                            <template
                                                v-for="(media, j) in article.media"
                                            >
                                                <img
                                                    v-if="
                                                        article.image_location ===
                                                            'weclapp' &&
                                                        media.collection_name ===
                                                            'weclapp_images'
                                                    "
                                                    class="w-full object-contain my-3 h-56"
                                                    :src="media.original_url"
                                                    :alt="media.name"
                                                />
                                                <img
                                                    v-else-if="
                                                        article.image_location ===
                                                            'local' &&
                                                        media.collection_name === 'main'
                                                    "
                                                    class="w-full object-contain my-3 h-56"
                                                    :src="media.original_url"
                                                    :alt="media.name"
                                                />
                                            </template>
                                        </template>
                                        <img
                                            v-else-if="defaultArticleImage"
                                            :src="'/storage/' + defaultArticleImage"
                                            alt="default-article-img"
                                            class="w-full object-contain my-3 h-56"
                                        />
                                        <img
                                            v-else
                                            src="/img/dummyimg.jpg"
                                            alt="dummy-img"
                                            class="w-full object-contain my-3 h-56"
                                        />
                                    </div>
                                </div>
                                <img
                                    v-else-if="defaultArticleImage"
                                    :src="'/storage/' + defaultArticleImage"
                                    alt="default-article-img"
                                    class="w-full object-contain my-3 h-56"
                                />
                                <img
                                    v-else
                                    src="/img/dummyimg.jpg"
                                    alt="dummy-img"
                                    class="w-full object-contain my-3 h-56"
                                />
                            </div>

                            <div
                                class="xl:flex xl:flex-wrap xl:justify-between xl:items-center mb-3"
                            >
                                <h2
                                    class="text-sm lg:text-base headline cursor-pointer"
                                    @click="
                                        toggleShipmentModal(task, shipitem.id, 'normal')
                                    "
                                    v-if="shipitem.title"
                                >
                                    {{ shipitem.title }}
                                </h2>
                                <h2 v-else>N/A</h2>
                                <h3 class="mt-3 xl:mt-0">
                                    <p class="flex flex-wrap">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="h-5 w-5"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                                            /></svg>#{{ task.salesOrderNumber }}
                                    </p>
                                </h3>
                            </div>
                            <p class="my-2">
                                {{ shipitem.articleNumber }}
                            </p>
                            <badge v-if="task.status" :color="badgeColor">
                                {{ ___("Status|" + task.status + "|content") }}
                            </badge>

                            <p
                                v-if="
                                    includeShipmentTrackingLink &&
                                    task.packageTrackingUrl
                                "
                                class="mt-5 inline-flex"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                    class="w-5 h-5 mr-1"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
                                    />
                                </svg>

                                <a
                                    v-if="isTrackingLinkAssemblyEnabled"
                                    :href="
                                        assembleTrackingLink(
                                            task.packageTrackingUrl,
                                            trackingVariable,
                                            task.packageTrackingNumber
                                        )
                                    "
                                    target="_blank"
                                >
                                    {{ ___("Pipeline|Tracking link|content") }}
                                </a>
                                <a
                                    v-else
                                    :href="task.packageTrackingUrl"
                                    target="_blank"
                                >
                                    {{ ___("Pipeline|Tracking link|content") }}
                                </a>
                            </p>

                            <div
                                class="flex justify-between items-center flex-wrap mt-3"
                            >
                                <div
                                    v-if="task.shippingDate"
                                    class="relative group cursor-pointer inline-flex items-center"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-5 w-5"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                    <span
                                        v-if="task.status == 'SHIPPED'"
                                        v-html="formatDate(task.shippingDate)"
                                    ></span>
                                    <div
                                        class="absolute bottom-0 hidden mb-6 group-hover:flex flex-col"
                                    >
                                        <span
                                            class="relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-black shadow-lg"
                                        >
                                            <span v-if="task.status == 'SHIPPED'">
                                                {{
                                                    ___("Pipeline|Shipped Date|content")
                                                }}</span
                                            >
                                            <span v-else>
                                                {{
                                                    ___(
                                                        "Pipeline|Not shipped yet|content"
                                                    )
                                                }}</span
                                            >
                                        </span>
                                        <div
                                            class="w-3 h-3 -mt-2 ml-1 transform rotate-45 bg-black"
                                        ></div>
                                    </div>
                                </div>
                                <div
                                    v-if="shipitem.quantity"
                                    class="relative group cursor-pointer inline-flex items-center"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-5 w-5"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                                        />
                                    </svg>
                                    <span>{{ shipitem.quantity }}</span>
                                    <div
                                        class="absolute bottom-0 hidden mb-6 group-hover:flex flex-col"
                                    >
                                        <span
                                            class="relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-black shadow-lg"
                                        >
                                            {{ ___("Pipeline|Quantity|content") }}</span
                                        >
                                        <div
                                            class="w-3 h-3 -mt-2 ml-1 transform rotate-45 bg-black"
                                        ></div>
                                    </div>
                                </div>

                                <button
                                    aria-label="Open Detail Modal"
                                    type="button"
                                    @click="
                                        toggleShipmentModal(task, shipitem.id, 'normal')
                                    "
                                    class="rounded-full outline-none focus:outline-none"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        x="0px"
                                        y="0px"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 172 172"
                                        style="fill: #000000"
                                    >
                                        <g
                                            fill="none"
                                            fill-rule="nonzero"
                                            stroke="none"
                                            stroke-width="1"
                                            stroke-linecap="butt"
                                            stroke-linejoin="miter"
                                            stroke-miterlimit="10"
                                            stroke-dasharray=""
                                            stroke-dashoffset="0"
                                            font-family="none"
                                            font-weight="none"
                                            font-size="none"
                                            text-anchor="none"
                                            style="mix-blend-mode: normal"
                                        >
                                            <path
                                                d="M0,172v-172h172v172z"
                                                fill="none"
                                            ></path>
                                            <g fill="#000000">
                                                <path
                                                    d="M86,14.33333c-39.49552,0 -71.66667,32.17115 -71.66667,71.66667c0,39.49552 32.17115,71.66667 71.66667,71.66667c39.49552,0 71.66667,-32.17115 71.66667,-71.66667c0,-39.49552 -32.17115,-71.66667 -71.66667,-71.66667zM86,28.66667c31.74921,0 57.33333,25.58412 57.33333,57.33333c0,31.74921 -25.58412,57.33333 -57.33333,57.33333c-31.74921,0 -57.33333,-25.58412 -57.33333,-57.33333c0,-31.74921 25.58412,-57.33333 57.33333,-57.33333zM78.83333,50.16667v14.33333h14.33333v-14.33333zM78.83333,78.83333v43h14.33333v-43z"
                                                ></path>
                                            </g>
                                        </g>
                                    </svg>
                                </button>
                            </div>
                    </div>
                </div>
            </template>
        </div>

        <Modal
            v-if="shipmentModalShown"
            @close="toggleShipmentModal"
            :data="modalData"
        >
            <template v-slot:header>
                <h3 class="text-subheader-font-size font-semibold">
                    {{ ___("General|ModalHeader|content") }}
                </h3>
            </template>

            <template v-slot:body>
                <div v-if="salesType == 'normal'">
                    <div v-for="(item, l) in modalData.shipmentItems" :key="l">
                        <div
                            v-if="item.id == itemid"
                            class="border-b border-solid border-gray-300"
                        >
                            <div class="xl:flex xl:justify-between mb-3">
                                <h1 class="headline">{{ item.title }}</h1>
                                <h2>{{ item.articleNumber }}</h2>
                            </div>
                            <div class="lg:flex lg:items-center">
                                <div
                                    v-if="item.local_article.length"
                                    class="flex-none"
                                >
                                    <div
                                        v-for="article in item.local_article"
                                        :key="article.id"
                                    >
                                        <template v-if="article.media.length">
                                            <template
                                                v-for="(
                                                    media, j
                                                ) in article.media"
                                            >
                                                <img
                                                    v-if="
                                                        article.image_location ===
                                                            'weclapp' &&
                                                        media.collection_name ===
                                                            'weclapp_images'
                                                    "
                                                    class="inline h-24 object-contain my-3"
                                                    :src="media.original_url"
                                                    :alt="media.name"
                                                />
                                                <img
                                                    v-else-if="
                                                        article.image_location ===
                                                            'local' &&
                                                        media.collection_name ===
                                                            'main'
                                                    "
                                                    class="inline h-24 object-contain my-3"
                                                    :src="media.original_url"
                                                    :alt="media.name"
                                                />
                                            </template>
                                        </template>
                                        <img
                                            v-else-if="defaultArticleImage"
                                            :src="
                                                '/storage/' +
                                                defaultArticleImage
                                            "
                                            alt="default-article-img"
                                            class="inline lg:h-24 object-contain my-3"
                                        />
                                        <img
                                            v-else
                                            src="/img/dummyimg.jpg"
                                            alt="dummy-img"
                                            class="inline lg:h-24 object-contain my-3"
                                        />
                                    </div>
                                </div>
                                <img
                                    v-else-if="defaultArticleImage"
                                    :src="'/storage/' + defaultArticleImage"
                                    alt="default-article-img"
                                    class="inline lg:h-24 object-contain my-3 flex-none"
                                />
                                <img
                                    v-else
                                    src="/img/dummyimg.jpg"
                                    alt="dummy-img"
                                    class="inline lg:h-24 object-contain my-3 flex-none"
                                />

                                <div class="pl-4">
                                    <p
                                        class="font-bold"
                                        v-html="item.description"
                                    ></p>
                                    <p>
                                        {{ ___("Pipeline|Quantity|content") }}:
                                        {{ item.quantity }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <h4 class="py-2 headline">
                            {{ ___("Shipment|Shipment Details|content") }}
                        </h4>
                        <badge
                            v-if="task.status"
                            :color="badgeColor"
                            class="mt-2"
                        >
                            {{ ___("Status|" + task.status + "|content") }}
                        </badge>

                        <span v-if="task.status == 'SHIPPED'">
                            {{ ___("Pipeline|Shipped Date|content") }}:
                            <span v-if="pipelineShippedDate =='shipped_date'">
                                <span v-if="modalData.hasOwnProperty('shippingDate')">
                                    {{formatDate(modalData.shippingDate)}}
                                </span>
                                <span v-else> - </span>
                            </span>
                            <span v-else-if="pipelineShippedDate =='shipped_status_date'">
                                {{ findShipmentDate(modalData.statusHistory) }}
                            </span>
                            <span v-else>-</span>
                        </span>
                        <span v-else>
                            {{ ___("Pipeline|Shipped Date|content") }}:
                            {{___("Pipeline|Not shipped yet|content")}}
                        </span>

                        <p>
                            {{ ___("Shipment|Shipment number|content") }}:
                            {{ modalData.shipmentNumber }}
                        </p>
                        <p>
                            {{ ___("Pipeline|Warehouse|content") }}:
                            <span v-if="modalData.warehouseLocal">{{
                                modalData.warehouseLocal
                            }}</span>
                            <span v-else>{{ modalData.warehouseName }}</span>
                        </p>
                        <p
                            v-if="
                                includeShipmentTrackingLink &&
                                modalData.packageTrackingUrl
                            "
                        >
                            {{ ___("Pipeline|Tracking link|content") }}:
                            <a
                                v-if="isTrackingLinkAssemblyEnabled"
                                :href="
                                    assembleTrackingLink(
                                        modalData.packageTrackingUrl,
                                        trackingVariable,
                                        modalData.packageTrackingNumber
                                    )
                                "
                                target="_blank"
                                class="inline-block mt-2 bg-primary-color text-primary-text-color border border-primary-color hover:bg-primary-text-color hover:text-primary-color font-bold uppercase text-sm py-2 px-4 rounded-full outline-none focus:outline-none"
                            >
                                {{
                                    ___(
                                        "Pipeline|Click to see tracking link|content"
                                    )
                                }}
                            </a>
                            <a
                                v-else
                                :href="modalData.packageTrackingUrl"
                                target="_blank"
                                class="inline-block mt-2 bg-primary-color text-primary-text-color border border-primary-color hover:bg-primary-text-color hover:text-primary-color font-bold uppercase text-sm py-2 px-4 rounded-full outline-none focus:outline-none"
                            >
                                {{
                                    ___(
                                        "Pipeline|Click to see tracking link|content"
                                    )
                                }}
                            </a>
                        </p>

                        <div
                            class="block md:flex items-center bg-primary-color text-primary-text-color text-sm font-bold px-4 py-3 my-3"
                            v-if="task.status == 'NEW'"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 mr-2"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                            <p>
                                {{
                                    ___("General|NewShipments|content", {
                                        team: teamName,
                                    })
                                }}
                            </p>
                        </div>
                        <div v-else>
                            <a
                                v-if="
                                    $page.props.user.show_shipment_view &&
                                    $page.props.user.show_article_prices
                                "
                                :href="'openshipementpdf/' + modalData.id"
                                target="_blank"
                                class="inline-block mt-2 bg-primary-color text-primary-text-color border border-primary-color hover:bg-white hover:text-black hover:border-black font-bold uppercase text-sm py-2 px-4 rounded-full outline-none focus:outline-none"
                            >
                                {{ ___("Pipeline|ShipmentDetail|content") }}
                            </a>
                        </div>

                        <div
                            v-if="modalData.local_order != null"
                            class="mt-3 border-t border-solid border-gray-300"
                        >
                            <h4 class="py-2 headline">
                                {{ ___("Orders|Order Details|content") }}
                            </h4>
                            <p>
                                {{ ___("Orders|Order number|content") }}:
                                {{ modalData.local_order.orderNumber }}
                            </p>

                            <p
                                v-if="
                                    modalData.local_order.orderNumberAtCustomer
                                "
                            >
                                {{
                                    ___(
                                        "Orders|Order number at Customer|content"
                                    )
                                }}:
                                {{
                                    modalData.local_order.orderNumberAtCustomer
                                }}
                            </p>

                            <p class="font-bold" v-if="!hideExpectedDates">
                                {{
                                    ___(
                                        "General|Expected Shipment Date|content"
                                    )
                                }}:
                                <span
                                    v-html="
                                        formatDate(
                                            modalData.local_order
                                                .plannedShippingDate
                                        )
                                    "
                                ></span>
                            </p>
                            <p
                                v-if="
                                    modalData.local_order.grossAmount &&
                                    $page.props.user.show_article_prices &&
                                    $page.props.user.show_order_view
                                "
                            >
                                {{ ___("General|Amount|content") }}:
                                {{
                                    formatCurrency(
                                        modalData.local_order.grossAmount
                                    )
                                }}
                            </p>

                            <a
                                v-if="
                                    $page.props.user.show_order_view &&
                                    $page.props.user.show_article_prices
                                "
                                :href="
                                    'openorderpdf/' + modalData.local_order.id
                                "
                                target="_blank"
                                class="inline-block mt-2 bg-primary-color text-primary-text-color border border-primary-color hover:bg-primary-text-color hover:text-primary-color font-bold uppercase text-sm py-2 px-4 rounded-full outline-none focus:outline-none"
                            >
                                {{ ___("Pipeline|OrderDetail|content") }}
                            </a>
                        </div>

                        <div
                            v-else
                            class="block md:flex items-center bg-primary-color text-primary-text-color text-sm font-bold px-4 py-3 my-3"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 mr-2"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="#fff"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                            <p>
                                {{
                                    ___(
                                        "Pipeline|Shipment without a sales order reference|content"
                                    )
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div
                        v-if="modalData.shipmentItems[0].id == itemid"
                        class="border-b border-solid border-gray-300"
                    >
                        <div class="xl:flex xl:justify-between mb-3">
                            <h1 class="headline">
                                {{ modalData.shipmentItems[0].title }}
                            </h1>
                            <h2>
                                {{ modalData.shipmentItems[0].articleNumber }}
                            </h2>
                        </div>
                        <div class="lg:flex lg:items-center">
                            <div
                                v-if="
                                    modalData.shipmentItems[0].local_article
                                        .length
                                "
                                class="flex-none"
                            >
                                <div
                                    v-for="article in modalData.shipmentItems[0]
                                        .local_article"
                                    :key="article.id"
                                >
                                    <template v-if="article.media.length">
                                        <template
                                            v-for="(media, j) in article.media"
                                        >
                                            <img
                                                v-if="
                                                    article.image_location ===
                                                        'weclapp' &&
                                                    media.collection_name ===
                                                        'weclapp_images'
                                                "
                                                class="inline h-24 object-contain my-3"
                                                :src="media.original_url"
                                                :alt="media.name"
                                            />
                                            <img
                                                v-else-if="
                                                    article.image_location ===
                                                        'local' &&
                                                    media.collection_name ===
                                                        'main'
                                                "
                                                class="inline h-24 object-contain my-3"
                                                :src="media.original_url"
                                                :alt="media.name"
                                            />
                                        </template>
                                    </template>
                                    <img
                                        v-else-if="defaultArticleImage"
                                        :src="'/storage/' + defaultArticleImage"
                                        alt="default-article-img"
                                        class="inline lg:h-24 object-contain my-3"
                                    />
                                    <img
                                        v-else
                                        src="/img/dummyimg.jpg"
                                        alt="dummy-img"
                                        class="inline lg:h-24 object-contain my-3"
                                    />
                                </div>
                            </div>
                            <img
                                v-else-if="defaultArticleImage"
                                :src="'/storage/' + defaultArticleImage"
                                alt="default-article-img"
                                class="inline lg:h-24 object-contain my-3 flex-none"
                            />
                            <img
                                v-else
                                src="/img/dummyimg.jpg"
                                alt="dummy-img"
                                class="inline lg:h-24 object-contain my-3 flex-none"
                            />

                            <div class="pl-4">
                                <p
                                    class="font-bold"
                                    v-html="
                                        modalData.shipmentItems[0].description
                                    "
                                ></p>
                                <p>
                                    {{ ___("Pipeline|Quantity|content") }}:
                                    {{ modalData.shipmentItems[0].quantity }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="mt-3">
                        <h4 class="py-2 headline">
                            {{ ___("Shipment|Shipment Details|content") }}
                        </h4>
                        <badge
                            v-if="task.status"
                            :color="badgeColor"
                            class="mt-2"
                        >
                            {{ ___("Status|" + task.status + "|content") }}
                        </badge>

                        <span>
                            {{ ___("Pipeline|Shipped Date|content") }}:
                            <span
                                v-if="task.status == 'SHIPPED'"
                                v-html="formatDate(modalData.shippingDate)"
                            ></span>
                            <span v-else>{{
                                ___("Pipeline|Not shipped yet|content")
                            }}</span>
                        </span>

                        <p>
                            {{ ___("Shipment|Shipment number|content") }}:
                            {{ modalData.shipmentNumber }}
                        </p>
                        <p>
                            {{ ___("Pipeline|Warehouse|content") }}:
                            <span v-if="modalData.warehouseLocal">{{
                                modalData.warehouseLocal
                            }}</span>
                            <span v-else>{{ modalData.warehouseName }}</span>
                        </p>
                        <p
                            v-if="
                                includeShipmentTrackingLink &&
                                modalData.packageTrackingUrl
                            "
                        >
                            {{ ___("Pipeline|Tracking link|content") }}:
                            <a
                                v-if="isTrackingLinkAssemblyEnabled"
                                :href="
                                    assembleTrackingLink(
                                        modalData.packageTrackingUrl,
                                        trackingVariable,
                                        modalData.packageTrackingNumber
                                    )
                                "
                                target="_blank"
                                class="inline-block mt-2 bg-primary-color text-primary-text-color border border-primary-color hover:bg-primary-text-color hover:text-primary-color font-bold uppercase text-sm py-2 px-4 rounded-full outline-none focus:outline-none"
                            >
                                {{
                                    ___(
                                        "Pipeline|Click to see tracking link|content"
                                    )
                                }}
                            </a>
                            <a
                                v-else
                                :href="modalData.packageTrackingUrl"
                                target="_blank"
                                class="inline-block mt-2 bg-primary-color text-primary-text-color border border-primary-color hover:bg-primary-text-color hover:text-primary-color font-bold uppercase text-sm py-2 px-4 rounded-full outline-none focus:outline-none"
                            >
                                {{
                                    ___(
                                        "Pipeline|Click to see tracking link|content"
                                    )
                                }}
                            </a>
                        </p>

                        <div
                            class="block md:flex items-center bg-primary-color text-primary-text-color text-sm font-bold px-4 py-3 my-3"
                            v-if="task.status == 'NEW'"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 mr-2"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                            <p>
                                {{
                                    ___("General|NewShipments|content", {
                                        team: teamName,
                                    })
                                }}
                            </p>
                        </div>
                        <div v-else>
                            <a
                                v-if="
                                    $page.props.user.show_shipment_view &&
                                    $page.props.user.show_article_prices
                                "
                                :href="'openshipementpdf/' + modalData.id"
                                target="_blank"
                                class="inline-block mt-2 bg-primary-color text-primary-text-color border border-primary-color hover:bg-white hover:text-black hover:border-black font-bold uppercase text-sm py-2 px-4 rounded-full outline-none focus:outline-none"
                            >
                                {{ ___("Pipeline|ShipmentDetail|content") }}
                            </a>
                        </div>

                        <div
                            v-if="modalData.local_order != null"
                            class="mt-3 border-t border-solid border-gray-300"
                        >
                            <h4 class="py-2 headline">
                                {{ ___("Orders|Order Details|content") }}
                            </h4>
                            <p>
                                {{ ___("Orders|Order number|content") }}:
                                {{ modalData.local_order.orderNumber }}
                            </p>

                            <p
                                v-if="
                                    modalData.local_order.orderNumberAtCustomer
                                "
                            >
                                {{
                                    ___(
                                        "Orders|Order number at Customer|content"
                                    )
                                }}:
                                {{
                                    modalData.local_order.orderNumberAtCustomer
                                }}
                            </p>

                            <p class="font-bold">
                                {{
                                    ___(
                                        "General|Expected Shipment Date|content"
                                    )
                                }}:
                                <span
                                    v-html="
                                        formatDate(
                                            modalData.local_order
                                                .plannedShippingDate
                                        )
                                    "
                                ></span>
                            </p>
                            <p
                                v-if="
                                    modalData.local_order.grossAmount &&
                                    $page.props.user.show_article_prices &&
                                    $page.props.user.show_order_view
                                "
                            >
                                {{ ___("General|Amount|content") }}:
                                {{
                                    formatCurrency(
                                        modalData.local_order.grossAmount
                                    )
                                }}
                            </p>

                            <a
                                v-if="
                                    $page.props.user.show_order_view &&
                                    $page.props.user.show_article_prices
                                "
                                :href="
                                    'openorderpdf/' + modalData.local_order.id
                                "
                                target="_blank"
                                class="inline-block mt-2 bg-primary-color text-primary-text-color border border-primary-color hover:bg-primary-text-color hover:text-primary-color font-bold uppercase text-sm py-2 px-4 rounded-full outline-none focus:outline-none"
                            >
                                {{ ___("Pipeline|OrderDetail|content") }}
                            </a>
                        </div>

                        <div
                            v-else
                            class="block md:flex items-center bg-primary-color text-primary-text-color text-sm font-bold px-4 py-3 my-3"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 mr-2"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="#fff"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                            <p>
                                {{
                                    ___(
                                        "Pipeline|Shipment without a sales order reference|content"
                                    )
                                }}
                            </p>
                        </div>
                    </div>
                    <div
                        v-if="salesBillofItemForPipeline != 'do_not_show'"
                        class="border-t border-solid border-gray-300 mt-5 pt-3"
                    >
                        <h4>{{ ___("Shop|Items included|content") }}: -</h4>

                        <table class="border-collapse w-full table-fixed">
                            <thead>
                                <tr>
                                    <th
                                        class="p-2 capitalize text-black border border-primary-color hidden lg:table-cell"
                                    >
                                        {{ ___("Shop|Article name|content") }}
                                    </th>
                                    <th
                                        class="p-2 capitalize text-black border border-primary-color hidden lg:table-cell"
                                    >
                                        {{ ___("Shop|Article id|content") }}
                                    </th>
                                    <th
                                        class="p-2 capitalize text-black border border-primary-color hidden lg:table-cell"
                                    >
                                        {{ ___("Shop|Article number|content") }}
                                    </th>
                                    <th
                                        class="p-2 capitalize text-black border border-primary-color hidden lg:table-cell"
                                    >
                                        {{ ___("Shop|Quantity|content") }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    class="text-sm lg:text-base shadow-md lg:shadow-none hover:bg-gray-300 bg-white border border-b flex lg:table-row flex-row lg:flex-row flex-wrap lg:flex-no-wrap mb-3 lg:mb-0 cursor-pointer"
                                    v-for="(
                                        shipmentItem, sl
                                    ) in modalData.shipmentItems"
                                    :key="sl"
                                    v-if="sl > 0"
                                >
                                    <td
                                        class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 lg:text-center lg:border lg:border-b inline-flex lg:table-cell relative lg:static"
                                    >
                                        <span
                                            class="lg:hidden text-gray-600 font-bold capitalize"
                                        >
                                            {{
                                                ___(
                                                    "Shop|Article name|content"
                                                )
                                            }}:
                                        </span>
                                        {{ shipmentItem.title }}
                                    </td>
                                    <td
                                        class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 lg:text-center lg:border lg:border-b inline-flex lg:table-cell relative lg:static"
                                    >
                                        <span
                                            class="lg:hidden text-gray-600 font-bold capitalize"
                                        >
                                            {{
                                                ___("Shop|Article id|content")
                                            }}:
                                        </span>
                                        {{ shipmentItem.articleId }}
                                    </td>
                                    <td
                                        class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 lg:text-center lg:border lg:border-b inline-flex lg:table-cell relative lg:static"
                                    >
                                        <span
                                            class="lg:hidden text-gray-600 font-bold capitalize"
                                        >
                                            {{
                                                ___(
                                                    "Shop|Article number|content"
                                                )
                                            }}:
                                        </span>
                                        {{ shipmentItem.articleNumber }}
                                    </td>
                                    <td
                                        class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 lg:text-center lg:border lg:border-b inline-flex lg:table-cell relative lg:static"
                                    >
                                        <span
                                            class="lg:hidden text-gray-600 font-bold capitalize"
                                        >
                                            {{ ___("Shop|Quantity|content") }}:
                                        </span>
                                        {{ shipmentItem.quantity }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>

            <template v-slot:footer> </template>
        </Modal>
    </div>
</template>

<script>
import Badge from "../Shared/Badge";
import { FormatCurrency } from "../../mixin/formatCurrency";
import { FormatDate } from "../../mixin/formatDate";
import Modal from "@/Components/Modal";
import { Pipeline } from "../../mixin/pipeline";

export default {
    components: {
        Badge,
        Modal,
    },
    mixins: [FormatCurrency, FormatDate, Pipeline],
    props: {
        includeShipmentTrackingLink: Boolean,
        isTrackingLinkAssemblyEnabled: Boolean,
        trackingVariable: String,
        salesBillofItemForPipeline: String,
        hideExpectedDates:Boolean,
        pipelineShippedDate:String
    },
    data() {
        return {
            shipmentModalShown: false,
        };
    },
    methods: {
        assembleTrackingLink(url, trackingVariable, trackingNumber) {
            let newUrl = url.replace(
                new RegExp(trackingVariable, "g"),
                trackingNumber
            );
            return newUrl;
        },
        findShipmentDate(statusArray){
            const foundItem = statusArray.find(item => item.status === 'SHIPPED');
            if(foundItem){
                return this.formatDate(foundItem.statusDate);
            }
            else{
                return '-' ;
            }
        }
    },
};
</script>
